import ActionButton from 'components/ActionButton';
import SearchBar from 'components/Autosuggest/Autosuggest';
import DropDown from 'components/FormFields/dropdown';
import _ from 'lodash';
import React, { useState } from 'react';
import { searchUserByName } from 'services';
import styles from './index.module.scss';

const CART_STATUSES = [{ name: 'All', value: '' }, { name: 'Active', value: 'ACTIVE' }, { name: 'Processed', value: 'PROCESSED' }];

const Filter = props => {
  const [status, setStatus] = useState('');
  const [user, setUser] = useState<Record<string, any>>({});
  const [userId, setUserId] = useState<string>('');
  const [userPhone, setUserPhone] = useState<string>('');
  const [userEmail, setUserEmail] = useState<string>('');

  const resetFilter = () => {
    setStatus('');
    setUser({});
    props.onSubmit({});
  };

  const handleSubmit = () => {
    let filterData: any = {
      status,
      userId,
      userEmail,
      userPhone,
    };
    filterData = _.omitBy(filterData, (v) => _.isUndefined(v) || _.isNull(v) || v === '');
    props.onSubmit(filterData);
  };

  const handleUserSelect = (suggestion: Record<string, any>) => {
    const user: Record<string, any> = {};
    user.id = suggestion.objectId;
    user.name = suggestion.full_name;
    setUser(user);
    setUserId(user.id);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['input-group']}>
        <DropDown
          title="Status"
          value={status}
          options={CART_STATUSES}
          onChange={(e) => {
            setStatus(e);
          }}
        />
      </div>
      <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>User</div>
        <div className={styles['autosuggest-input']}>
          <SearchBar
            isUser={true}
            value={user.name || ''}
            setValue={value => setUser({ ...user, name: value })}
            searchAPI={searchUserByName}
            searchAPIParamKey={'searchTerm'}
            onSuggestionClicked={handleUserSelect}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User ID</div>
        <input
          className={'form-control'}
          value={userId}
          onChange={e => setUserId(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User Phone</div>
        <input
          className={'form-control'}
          value={userPhone}
          onChange={e => setUserPhone(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>User Email</div>
        <input
          className={'form-control'}
          value={userEmail}
          onChange={e => setUserEmail(e.target.value)}
        />
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;